import React from "react";
import {
  TabsRow,
  TabsLeft,
  TabButton,
} from "../../pages/Home/HomeStyled";
import FilterBar from "../../pages/Home/FilterBar/FilterBar";
import PropTypes from 'prop-types';

const TabContainer = ({
  activeTab,
  handleTabChange,
  isLoading = false,
  isInitialLoad = false,
  filterState = {},
  handleSelect,
  handleFilterChange,
  handleStateChange,
  statusOptions = [],
  dueOnOptions = [],
  getChipCount,
  tabs = [],
  handleChangePageSize,
  children
}) => {
  return (
    <>
      <div>
        <TabsRow>
          <TabsLeft>
            {tabs?.map((tab) => (
              <TabButton
                key={tab.key}
                active={activeTab === tab.key}
                onClick={() => handleTabChange?.(tab.key)}
              >
                {tab.label}
              </TabButton>
            ))}
          </TabsLeft>
        </TabsRow>

        <FilterBar
          activeTab={activeTab}
          handleSelect={handleSelect}
          isLoading={isLoading}
          handleFilterChange={handleFilterChange}
          filterState={filterState}
          handleStateChange={handleStateChange}
          statusOptions={statusOptions}
          dueOnOptions={dueOnOptions}
          getChipCount={getChipCount}
          handleChangePageSize={handleChangePageSize}
        />
      </div>
      {children}
    </>
  );
};

TabContainer.propTypes = {
  activeTab: PropTypes.string.isRequired,
  handleTabChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isInitialLoad: PropTypes.bool,
  filterState: PropTypes.object.isRequired,
  handleSelect: PropTypes.func.isRequired,
  handleFilterChange: PropTypes.func.isRequired,
  handleStateChange: PropTypes.func.isRequired,
  statusOptions: PropTypes.array.isRequired,
  dueOnOptions: PropTypes.array,
  getChipCount: PropTypes.func.isRequired,
  handleChangePageSize: PropTypes.func,
  tabs: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  children: PropTypes.node.isRequired
};

export default TabContainer; 